export default {
  setLastServiceWorkerUpdate(state, timestamp) {
    state.lastServiceWorkerUpdate = timestamp
  },
  setAppMobileInstallationBlockHiddenAt(state, timestamp) {
    state.appMobileInstallationBlockHiddenAt = timestamp
  },
}
